<template>
  <header class="header">
    <slot name="position-left"></slot>
    <notifications class="header__item" />
    <user-menu class="header__item" />
    <lang-select class="header__item" />
    <slot name="position-right"></slot>
  </header>
</template>

<script>
  import LangSelect from './layout-default-header-lang-select';
  import UserMenu from './layout-default-header-user-menu';
  import Notifications from './layout-default-header-notifications';

  export default {
    components: { LangSelect, UserMenu, Notifications }
  };
</script>
